<script setup lang="ts">
  import { useRestaurant } from '@/composition/use-restaurant';
  import { useTimeoutFn } from '@vueuse/core';
  import { computed, ref, watch } from 'vue';
  import ModalPosNewOrderSummaryItems from './ModalPosNewOrderSummaryItems.vue';
  import ModalPosNewOrderSummaryFooter from './ModalPosNewOrderSummaryFooter.vue';

  const restaurantHelper = useRestaurant();

  const props = defineProps<{
    value: boolean;
  }>();

  const emit = defineEmits(['input']);

  const value = computed({
    get: () => props.value,
    set: (value) => emit('input', value),
  });

  const bgClass = computed(() => ``);

  const hideContent = ref(false);
  const hideTimeout = useTimeoutFn(
    () => {
      hideContent.value = true;
    },
    200,
    { immediate: false }
  );

  watch(
    value,
    (newValue) => {
      if (newValue) {
        hideContent.value = false;
        hideTimeout.stop();
      } else {
        hideTimeout.start();
      }
    },
    { immediate: true }
  );
</script>

<template>
  <div class="pos-summary-container">
    <div class="pos-summary" :class="{ 'tw-active': value }" v-bind="$attrs">
      <v-card class="inner" flat tile>
        <div class="header" :class="bgClass" @click="value = false">
          <v-icon size="24">mdi-cart</v-icon>
          <span class="title">Pedido</span>
          <div class="spacer"></div>
          <v-icon size="24">mdi-chevron-down</v-icon>
        </div>
        <div v-show="!hideContent" class="content">
          <ModalPosNewOrderSummaryItems />
        </div>
      </v-card>
    </div>
    <div
      class="overlay"
      :class="{ 'tw-active': value }"
      @click="value = false"
    ></div>
  </div>
</template>

<style scoped lang="scss">
  .pos-summary {
    @apply tw-absolute tw-transition-all tw-left-1/2 -tw-translate-x-1/2 tw-transform-gpu tw-z-[100] tw-top-full tw-translate-y-[6rem];
    @apply tw-h-[30rem] tw-max-h-full tw-w-full xs:tw-w-[24rem] tw-max-w-full tw-flex tw-p-4;

    .inner {
      @apply tw-rounded-xl tw-w-full tw-h-full tw-overflow-hidden;
      @apply tw-flex tw-flex-col;

      .header {
        @apply tw-px-4 tw-py-3 tw-flex tw-items-center tw-space-x-1 tw-cursor-pointer tw-h-14 tw-border-b tw-border-dashed tw-flex-none;
      }

      .content {
        @apply tw-flex-1 tw-overflow-y-auto;
      }

      /* .footer {
        @apply tw-border-t tw-border-dashed tw-flex-none;
      } */
    }

    &.tw-active {
      @apply -tw-translate-y-full;

      .inner {
        @apply tw-shadow-lg;
      }
    }
  }

  .overlay {
    @apply tw-absolute tw-bg-black tw-inset-0 tw-top-0 tw-left-0 tw-right-0 tw-bottom-0 tw-opacity-0 tw-transition-opacity tw-pointer-events-none;
    z-index: 1;

    &.tw-active {
      @apply tw-opacity-10 tw-pointer-events-auto;
    }
  }
</style>
